import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { GET_VENDOR_CAR_REGIONS, GET_VENDOR_CAR_REGIONS_SUCCESS, GET_VENDOR_CAR_REGIONS_ERROR } from './../../../actionType.js';
import apiCall from '../../../apiCall';

function* getVendorCarRegions({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/vendor/car-regions`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: GET_VENDOR_CAR_REGIONS_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_VENDOR_CAR_REGIONS_ERROR,
        payload: response?.response?.data?.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_VENDOR_CAR_REGIONS_ERROR, payload: error });
  }
}

export function* watchGetVendorCarRegions() {
  yield takeEvery(GET_VENDOR_CAR_REGIONS, getVendorCarRegions);
}

function* getVendorCarRegionsSaga() {
  yield all([fork(watchGetVendorCarRegions)]);
}

export default getVendorCarRegionsSaga;
